module.exports = __webpack_public_path__ + "img/hero_mobile.3f2b60df.png";